import React, { useState } from "react";
import { useNotify, useRecordContext, usePermissions } from "react-admin";
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField as MuiTextField,
} from "@mui/material";
import SmsIcon from "@mui/icons-material/Sms";

const getToken = () => JSON.parse(localStorage.getItem("token"));

const sendBeneficiarySms = async (id, message) => {
  const res = await fetch(
    `${process.env.REACT_APP_URL}/admin/beneficiaries/${id}/sms`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({ message }),
    }
  );
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.message || "Failed to send SMS");
  }
  return res.json().catch(() => ({}));
};

// Row/detail-view action: opens a small dialog to SMS a single beneficiary
const BeneficiarySmsButton = () => {
  const record = useRecordContext();
  const { permissions } = usePermissions();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const notify = useNotify();

  if (!record || !["admin", "operater"].includes(permissions)) return null;

  const handleOpen = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = (e) => {
    e?.stopPropagation?.();
    if (loading) return;
    setOpen(false);
    setMessage("");
  };

  const handleSend = async (e) => {
    e.stopPropagation();
    setLoading(true);
    try {
      await sendBeneficiarySms(record.id, message.trim());
      notify(`SMS sent to ${record.name || record.phonenumber}`, { type: "success" });
      setOpen(false);
      setMessage("");
    } catch (err) {
      notify(`Error sending SMS: ${err.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip title="Send SMS">
        <IconButton size="small" onClick={handleOpen}>
          <SmsIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" onClick={(e) => e.stopPropagation()}>
        <DialogTitle>Send SMS to {record.name || record.phonenumber}</DialogTitle>
        <DialogContent>
          <MuiTextField
            autoFocus
            fullWidth
            multiline
            minRows={4}
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSend}
            disabled={loading || !message.trim()}
          >
            {loading ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BeneficiarySmsButton;
